import React, { useEffect, useRef } from 'react';

function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      // Tab arka plana alındığında (visibilityState='hidden') API çağrısı yapma.
      // Bu sayede kullanıcı başka bir sekmede çalışırken gereksiz SP tüketimi önlenir.
      if (document.visibilityState === 'hidden') return;
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

export default useInterval
